import { render, staticRenderFns } from "./modelIndex.vue?vue&type=template&id=87441066&scoped=true&"
import script from "./modelIndex.vue?vue&type=script&lang=js&"
export * from "./modelIndex.vue?vue&type=script&lang=js&"
import style0 from "./modelIndex.vue?vue&type=style&index=0&id=87441066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87441066",
  null
  
)

export default component.exports